export enum ConfigValueId {
	StalePremiseCheckDelay = 'StalePremiseCheckDelay',
	StaleReportedCallDelay = 'StaleReportedCallDelay',

	AutomaticReReportDelay = 'AutomaticReReportDelay',
	AutomaticReReportPredictedStatuses = 'AutomaticReReportPredictedStatuses',

	NewAmiReportedCallDelay = 'NewAmiReportedCallDelay',

	EstimateNotificationThresholdEarlier = 'EstimateNotificationThresholdEarlier',
	EstimateNotificationThresholdLater = 'EstimateNotificationThresholdLater',
	RecentlyClosedOrderTreshold = 'RecentlyClosedOrderTreshold',
	StatusLookups = 'StatusLookups',
	CauseCodeLookups = 'CauseCodeLookups',
	ReportNotificationTriggerLookups = 'ReportNotificationTriggerLookups',
	ErrorLookups = 'ErrorLookups',
	EstimateActivationDelay = 'EstimateActivationDelay',
	EstimateExpiryNotificationDelay = 'EstimateExpiryNotificationDelay',
	SendNotifications = 'SendNotifications',
	ReportedCallCancellationDelay = 'ReportedCallCancellationDelay',
	RestorePowerOnCallCanceled = 'RestorePowerOnCallCanceled',
	RestorePowerOnCallAutoclosed = 'RestorePowerOnCallAutoclosed',
	RestorePowerOnCallClosedForNonAmi = 'RestorePowerOnCallClosedForNonAmi',
	RestorePowerOnCallSDLTSOK = 'RestorePowerOnCallSDLTSOK',

	ModeLookups = 'ModeLookups',

	ConfirmationCodeLookups = 'ConfirmationCodeLookups',
	NotificationCodeLookups = 'NotificationCodeLookups',
	EstimateDateVariantLookups = 'EstimateDateVariantLookups',
	MeterAlarmProcessing = 'MeterAlarmProcessing',

	EmpathyCodeLookups = 'EmpathyCodeLookups',
	EngineeringCodeLookups = 'EngineeringCodeLookups',

	WismoStaleCallCheckBatchSize = 'WismoStaleCallCheckBatchSize',
	WismoPowerStatusCheckBatchSize = 'WismoPowerStatusCheckBatchSize',
	MeterInterrogationBatchSize = 'MeterInterrogationBatchSize',

	LogPostingToQueues = 'LogPostingToQueues',
	LogMessageIds = 'LogMessageIds',

	UseLastGoodReadDateForGoodPowerStatus = 'UseLastGoodReadDateForGoodPowerStatus',
	CancelAmiCallsBeforeLastGoodRead = 'CancelAmiCallsBeforeLastGoodRead',

	SinglePONNotificationThreshold = 'SinglePONNotificationThreshold',

	InternalCallDelay = 'InternalCallDelay',
	SkipPremiseCallCreationForIntentionalJobs = 'SkipPremiseCallCreationForIntentionalJobs',

	MessageVariants = 'MessageVariants',

	TransactionalDocumentsTTL = 'TransactionalDocumentsTTL',
	HistoricalDocumentsTTL = 'HistoricalDocumentsTTL',
	SendTriageCrewArrivalNotifications = 'SendTriageCrewArrivalNotifications',

	PendingReportTimeoutInMinutes = 'PendingReportTimeoutInMinutes',

	WaitForFollowupJobsBeforeClosingCall = 'WaitForFollowupJobsBeforeClosingCall',
	SendNonOutageFollowUpNotifications = 'SendNonOutageFollowUpNotifications',

	SendEngineeringWorkNotifications = 'SendEngineeringWorkNotifications',
}
